window.segmentos = {};
window.gmap = false;
window.mapmarkers = new Array;

window.segmentosmask = '<button class="button" onclick="new ToggleMakrs(\'{{id}}\')">\
		<span class="ct"><img class="img" src="{{icon}}" /></span><span class="name">{{name}} ({{total}})</span></button><ul class="ul hidden" id="ul{{id}}">\
	</ul>';

window.empmask = '<li><button onclick="calculateAndDisplayRoute(directionsService, directionsDisplay, \'{{lat}},{{lng}}\', \'{{la}},{{lo}}\');" class="click"><span class="metros">{{distance}}</span><span class="emp">{{name}}</span></button></li>';

/* RENDER LISTA */
window.RenderEstabelecimento = function(){

	var um = new Array;
	for(var s in segmentos){
		if(segmentos[s]){
			if(segmentos[s].total && segmentos[s].name){
				um.push({
					id: s,
					total: segmentos[s].total,
					name: segmentos[s].name,
					icon: segmentos[s].icon
				});
			}
		}
	}

	Boss.render(um, {
		renderTo: 'proximidades',
		mask: segmentosmask,
		empty: '<button class="button"><span class="name">Parece que este imóvel é bem afastado!</span></button>'
	});

	for(var s in segmentos){
		var temp = new Array();
		if(segmentos[s].emps){

			for(var e in segmentos[s].emps){
				temp.push({
					'name': segmentos[s].emps[e].name,
					'pin': segmentos[s].pin,
					'lat': segmentos[s].emps[e].lat,
					'lng': segmentos[s].emps[e].lng,
					'la': segmentos[s].emps[e].la,
					'lo': segmentos[s].emps[e].lo,
					'distance': segmentos[s].emps[e].distance
				});
			}
		}

		if(Boss.getById('ul'+s)){
			Boss.render(temp, {
				renderTo: 'ul'+s,
				mask: empmask,
				empty: ''
			});
		}
	}
};

class ToggleMakrs{

	constructor(type){

		/* CLEAR MARKERS */
		for (var i = 0; i < mapmarkers.length; i++) {
			mapmarkers[i].setMap(null);
		}

		var targt = Boss.getById('ul'+type);
		if(targt.classList.contains('hidden')){

			targt.classList.remove('hidden');
			for(var emp in segmentos[type].emps){
				this.createMarker(segmentos[type].emps[emp], type);
			}
		}else{
			targt.classList.add('hidden');
		}
	}

	createMarker(emp, type){

		var point_a = new google.maps.LatLng(emp.lat, emp.lng);
		var point_b = new google.maps.LatLng(lat, lng);

		var distance = google.maps.geometry.spherical.computeDistanceBetween(point_a, point_b);
		distance = distance.toFixed(0)+'m';

		var marker = new google.maps.Marker({
			map: gmap,
			position: point_a,
			icon: emp.pin
		});

		mapmarkers.push(marker);

		google.maps.event.addListener(marker, 'click', function() {
		  infowindow.setContent('<div class="distance">'+distance+'</div><div class="name">'+emp.name+'</div>');
		  infowindow.open(gmap, this);
		});
	}
};

class Mapa{

	constructor(m, la, lo){

		this.id = m;
		window.lat = la;
		window.lng = lo;

		window.infowindow = new google.maps.InfoWindow();
		window.directionsService = new google.maps.DirectionsService;
		window.directionsDisplay = new google.maps.DirectionsRenderer({
			suppressMarkers: true
		});

		window.calculateAndDisplayRoute = function(directionsService, directionsDisplay, destination, origin){
			directionsService.route({
				origin: origin,
				destination: destination,
				travelMode: 'DRIVING'
			}, function(response, status) {
				if(status === 'OK') {
					directionsDisplay.setDirections(response);
				}
			});
		};

		this.clear();

		this.mapstyle = [{
			'featureType': 'poi.business',
			'stylers': [
				{
					'visibility': 'off'
				}
			]
		}];
	}

	clear(){

		window.segmentos = {
			gym: {
				'icon': '/jnh/icones/SVG/academia.svg',
				'pin': '/jnh/icones/academia.png',
				'name': 'Academias',
				'radius': '500'
			},
			night_club: {
				'icon': '/jnh/icones/SVG/balada.svg',
				'pin': '/jnh/icones/balada.png',
				'name': 'Baladas/Pubs',
				'radius': '500'
			},
			bank: {
				'icon': '/jnh/icones/SVG/banco.svg',
				'pin': '/jnh/icones/banco.png',
				'name': 'Bancos',
				'radius': '500'
			},
			school: {
				'icon': '/jnh/icones/SVG/escola.svg', 
				'pin': '/jnh/icones/escola.png',
				'name': 'Escolas',
				'radius': '500'
			},
			pharmacy: {
				'icon': '/jnh/icones/SVG/farmacia.svg',
				'pin': '/jnh/icones/farmacia.png',
				'name': 'Farmácias',
				'radius': '500'
			},
			hospital: {
				'icon': '/jnh/icones/SVG/hospital.svg',
				'pin': '/jnh/icones/hospital.png',
				'name': 'Hospitais/Postos de Saúde',
				'radius': '5000'
			},
			bakery: {
				'icon': '/jnh/icones/SVG/padaria.svg',
				'pin': '/jnh/icones/padaria.png',
				'name': 'Padarias',
				'radius': '500'
			},
			park: {
				'icon': '/jnh/icones/SVG/parque.svg',
				'pin': '/jnh/icones/parque.png',
				'name': 'Parques',
				'radius': '8000'
			},
			gas_station: {
				'icon': '/jnh/icones/SVG/combustivel.svg',
				'pin': '/jnh/icones/combustivel.png',
				'name': 'Postos de Combustíveis',
				'radius': '500'
			},
			restaurant: {
				'icon': '/jnh/icones/SVG/restaurante.svg',
				'pin': '/jnh/icones/restaurante.png',
				'name': 'Restaurantes',
				'radius': '500'
			},
			university: {
				'icon': '/jnh/icones/SVG/universidade.svg',
				'pin': '/jnh/icones/universidade.png',
				'name': 'Universidades',
				'radius': '8000'
			}
		};
	}

	render(){

		var map = Boss.getById(this.id);
		var largura = map.clientWidth;

		window.gmap = new google.maps.Map(document.getElementById(this.id), {
			center: {'lat': lat, 'lng': lng},
			zoom: 16,
			mapTypeControl: true,
			mapTypeControlOptions: {
				style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
				position: google.maps.ControlPosition.TOP_CENTER
			},
			zoomControl: true,
			zoomControlOptions: {
				position: google.maps.ControlPosition.LEFT_CENTER
			},
			scaleControl: true,
			streetViewControl: true,
			streetViewControlOptions: {
				position: google.maps.ControlPosition.LEFT_TOP
			},
			styles: this.mapstyle
		});

		directionsDisplay.setMap(gmap);

		var service = new google.maps.places.PlacesService(gmap);

		/* MARCADOR DO IMÓVEL*/
		var marker = new google.maps.Marker({
			position: {'lat': lat, 'lng': lng},
			animation: google.maps.Animation.DROP,
			map: gmap,
			title: '{$imo_descricao}',
			draggable: false,
			icon: '/jnh/icones/pin.png'
		});

		// LOCALIZA SEGMENTOS
		for (var ss in segmentos){
			service.nearbySearch({
				location: {'lat': lat, 'lng': lng},
				radius: segmentos[ss].radius,
				types: [ss]
			}, findbussiness);
		}

		function findbussiness(results, status) {
			if (status == google.maps.places.PlacesServiceStatus.OK) {
				for (var i = 0; i < results.length; i++) {
					var place = results[i];

					if(place.types && place.types.length > 0){
						var g = place.types[0];

						if(!segmentos[g]){
							segmentos[g] = {};
						}
						if(!segmentos[g]['total']){
							segmentos[g]['total'] = 0;
						}
						if(!segmentos[g]['emps']){
							segmentos[g]['emps'] = {};
						}
						if(!segmentos[g]['emps'][i]){
							segmentos[g]['emps'][i] = {};
						}

						var point_a = new google.maps.LatLng(place.geometry.location.lat(), place.geometry.location.lng());
						var point_b = new google.maps.LatLng(lat, lng);
						var distance = google.maps.geometry.spherical.computeDistanceBetween(point_a, point_b);

						distance = distance.toFixed(0);

						if(distance < 1000){
							distance = distance+'m';
						}else{
							distance = (distance / 1000).toFixed(1).replace('.', ',')+'km';
						}

						segmentos[g]['emps'][i] = {
							'id': place.id,
							'pin': segmentos[g].pin,
							'name': place.name,
							'lat': place.geometry.location.lat(),
							'lng': place.geometry.location.lng(),
							'la': lat,
							'lo': lng,
							'distance': distance
						};

						segmentos[g]['total'] = segmentos[g]['total'] + 1;
					}
				}
			}

			Boss.delayPersistent2(function(){
				RenderEstabelecimento();
			}, 300, 'mapa');
		}

		Boss.evts.add('fakeresize', window, function(evts){
			var screensizes = Boss.screensizes();
			if(lastWidth !== screensizes.viewWidth){
				lastWidth = screensizes.viewWidth;
				var center = gmap.getCenter();
				google.maps.event.trigger(gmap, 'resize');
				gmap.setCenter(center);
			}
		});
	}
};